
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class Rioplay8AllowedDevicesGrid extends Serenity.EntityGrid<Rioplay8AllowedDevicesRow, any> {
        protected getColumnsKey() { return Rioplay8AllowedDevicesColumns.columnsKey; }
        protected getDialogType() { return Rioplay8AllowedDevicesDialog; }
        protected getIdProperty() { return Rioplay8AllowedDevicesRow.idProperty; }
        protected getInsertPermission() { return Rioplay8AllowedDevicesRow.insertPermission; }
        protected getLocalTextPrefix() { return Rioplay8AllowedDevicesRow.localTextPrefix; }
        protected getService() { return Rioplay8AllowedDevicesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}